// Updated OrderAPIs.js
import { getToken } from "../utils/auth";
import { API_BASE_URL } from './URL_Header';

export const fetchOrders = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllOrders`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchOrderById = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetOrder/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchOrderById failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch order");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const createOrder = async (order) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Order/MakeOrder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(order),
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`createOrder failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to create order");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const updateOrder = async (id, order) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/EditOrder/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(order),
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`updateOrder failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to update order");
    }
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const deleteOrder = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/DeleteOrder/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`deleteOrder failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to delete order");
    }
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};
//-----------------------------Statuses---------------------
export const fetchNewOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllNewOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchNewOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch new orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchHoldOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllHoldOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchHoldOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch hold orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchChangesOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllChangesOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchChangesOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch changes orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchOldOrders = async (page = 0, pageSize = 10, date = null) => {
  try {
    let url = `${API_BASE_URL}/Order/GetAllOldOrders?page=${page}&pageSize=${pageSize}`;
    if (date) {
      url += `&date=${encodeURIComponent(date)}`;
    }
    console.log(`Fetching old orders: ${url}`);
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchOldOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch old orders");
    }
    const data = await response.json();
    console.log(`fetchOldOrders succeeded: ${data.length} orders`);
    return data;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchSpamOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllSpamOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchSpamOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch spam orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchConfirmedOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllConfirmedOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchConfirmedOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch confirmed orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};
//-----------------------------Purchase---------------------
export const fetchUnderPurchaseOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllUnderPurchaseOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchUnderPurchaseOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch under purchase orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchWaitingConfirmingOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllWaitingConfirmingOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchWaitingConfirmingOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch under purchase orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchCanceledOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllCanceledOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchCanceledOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch under purchase orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchConfirmingOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetAllConfirmingOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchConfirmingOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch under purchase orders");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};
// Bulk Orders (≥ 4 items) - usually need deposit
export const fetchDepositRequiredOrders = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetDepositRequiredOrders?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchDepositRequiredOrders failed: ${response.status} - ${errorText}`);
      throw new Error("فشل جلب الطلبات الكبيرة");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message || "خطأ أثناء جلب الطلبات الكبيرة");
  }
};

// Custom Design Orders
export const fetchCustomOrderRequests = async (page = 0, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetCustomOrderRequests?page=${page}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchCustomOrderRequests failed: ${response.status} - ${errorText}`);
      throw new Error("فشل جلب طلبات التصميم المخصص");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message || "خطأ أثناء جلب طلبات التصميم المخصص");
  }
};
//------------------------------Totals & Summaries--------------------
export const fetchUniqueOldDates = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetUniqueOldDates`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchUniqueOldDates failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch unique old dates");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchNewOrdersTotals = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetNewOrdersTotals`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchNewOrdersTotals failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch new orders totals");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchHoldOrdersTotals = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetHoldOrdersTotals`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchHoldOrdersTotals failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch hold orders totals");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchChangesOrdersTotals = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetChangesOrdersTotals`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchChangesOrdersTotals failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch changes orders totals");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchOldOrdersTotals = async (date = null) => {
  try {
    let url = `${API_BASE_URL}/Order/GetOldOrdersTotals`;
    if (date) {
      url += `?date=${encodeURIComponent(date)}`;
    }
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchOldOrdersTotals failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch old orders totals");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchNewOrdersSummary = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetNewOrdersSummary`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchNewOrdersSummary failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch new orders summary");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchHoldOrdersSummary = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetHoldOrdersSummary`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchHoldOrdersSummary failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch hold orders summary");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchChangesOrdersSummary = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetChangesOrdersSummary`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchChangesOrdersSummary failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch changes orders summary");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchOldOrdersSummary = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetOldOrdersSummary`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`fetchOldOrdersSummary failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to fetch old orders summary");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchDepositRequiredSummary = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetDepositRequiredSummary`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("فشل جلب ملخص الطلبات الكبيرة");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchCustomOrdersSummary = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/GetCustomOrdersSummary`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("فشل جلب ملخص طلبات التصميم المخصص");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const deleteAllNewOrders = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/DeleteAllNewOrders`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`deleteAllNewOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to delete all new orders");
    }
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const deleteAllOldOrders = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/DeleteAllOldOrders`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`deleteAllOldOrders failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to delete all old orders");
    }
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

// api/OrderAPIs.js
export const updateOrderStatus = async (id, status, reason = null, fullNote = null) => {
  try {
    const payload = { status };
    
    // إذا كان هناك سبب، نضيفه
    if (reason && reason.trim()) {
      payload.reason = reason.trim();
    }

    // إذا كان هناك note كاملة، نرسلها
    if (fullNote !== null) {
      payload.note = fullNote;
    }

    const response = await fetch(
      `${API_BASE_URL}/Order/UpdateOrderStatus/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`updateOrderStatus failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("فشل تحديث حالة الطلب");
    }

    return await response.json();
  } catch (err) {
    throw new Error(err.message || "حدث خطأ أثناء التحديث");
  }
};

export const revertToNew = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/RevertToNew/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`revertToNew failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to revert order to new");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const searchOrdersByPhone = async (phone) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/SearchOrdersByPhone?phone=${encodeURIComponent(phone)}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`searchOrdersByPhone failed: Status ${response.status}, Response: ${errorText}`);
      throw new Error("Failed to search orders by phone");
    }
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const checkDuplicatePhoneCount = async (currentOrderId, phone1, phone2) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Order/CheckDuplicatePhoneCount/${currentOrderId}?` +
      new URLSearchParams({
        phone1: phone1 || "",
        phone2: phone2 || "",
      }),
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error("فشل في التحقق من تكرار الرقم");
    }

    return await response.json(); // يرجع عدد الطلبات
  } catch (err) {
    throw new Error(err.message);
  }
};
